import { render } from "./ShippingListsRecipientsTab.vue?vue&type=template&id=7513e6a7"
import script from "./ShippingListsRecipientsTab.vue?vue&type=script&lang=js"
export * from "./ShippingListsRecipientsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__